import React, { useContext, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { Icon } from '../icon';
import { AlertContainer, AlertLink, CloseButton, ContentWrapper, DescriptionContent, IconWrapper, TextContent, TitleContent, } from './mixins';
export const Alert = ({ title, description, link, alertOptions = { variant: 'info', showClose: false }, closeHandler, }) => {
    const { variant = 'info', showClose = false } = alertOptions;
    const { colors } = useContext(ThemeContext);
    const [visibleComponent, setVisibleComponent] = useState(true);
    const [hideComponent, setHideComponent] = useState(false);
    const [closeComponent, setCloseComponent] = useState(false);
    // Mapeo de variantes a iconos
    const IconsCollection = {
        success: React.createElement(Icon, { name: "icon-bold-checkmark-circle", size: "20", color: colors.success.normal }),
        warning: React.createElement(Icon, { name: "icon-bold-alert-triangle", size: "20", color: colors.warning.normal }),
        info: React.createElement(Icon, { name: "icon-bold-info", size: "20", color: colors.info.normal }),
        danger: React.createElement(Icon, { name: "icon-bold-close-circle", size: "20", color: colors.danger.normal }),
    };
    const onClose = () => {
        setHideComponent(true);
        setTimeout(() => {
            setCloseComponent(true);
            setVisibleComponent(false);
        }, 350);
        if (closeHandler) {
            closeHandler();
        }
    };
    if (!visibleComponent) {
        return null;
    }
    return (visibleComponent && (React.createElement(AlertContainer, { variant: variant, hide: hideComponent, close: closeComponent },
        React.createElement(ContentWrapper, null,
            React.createElement(IconWrapper, null, IconsCollection[variant]),
            React.createElement(TextContent, null,
                React.createElement(TitleContent, null, title),
                description && React.createElement(DescriptionContent, null, description),
                (link === null || link === void 0 ? void 0 : link.url) && (link === null || link === void 0 ? void 0 : link.content) && (React.createElement(AlertLink, Object.assign({ href: link.url }, ((link === null || link === void 0 ? void 0 : link.target) && { target: link === null || link === void 0 ? void 0 : link.target })), link.content)))),
        showClose && (React.createElement(CloseButton, { type: "button", onClick: () => onClose() },
            React.createElement(Icon, { name: "icon-light-close", size: "24", color: colors.gray100 }))))));
};
